import styled from 'styled-components'

export default styled.article`
  display: flex;
  position: fixed;
  background: #0F2A4150;
  position: fixed;
  flex-direction: column;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  z-index: 100;

  .frame {
    display: flex;
    flex-direction: column;
    background: white;
    width: auto;
    border-radius: 4px;
    padding: 16px 8px;
    box-shadow: 0 4px 10px 0 rgba(66, 74, 97, 0.15);
    max-height: 80vh;
    overflow: hidden;
  }
  
  &.small {
    .frame {
      width: 500px;
      padding: 40px;
      box-sizing: border-box;
      border-radius: 20px;

      .spinner-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 40px;
      }

      header{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        img {
          width: 24px;
          height: 24px;
        }

        h3 {
          font-size: 24px;
          font-weight: bold;
          letter-spacing: 0;
          line-height: 33px;
          text-align: center;
          margin: 0 0 12px;
        }

        &.vertical {
          flex-direction: column;
          justify-content: center;
          align-items: center;

          img {
            width: 64px;
            height: 64px
          }
        }
      }

      .title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 16px;
        margin-bottom: 32px;
        
        img {
          width: 64px;
          height: 64px;
        }

        span {
          color: ${ ({ theme }) => theme.colors.primary };
          font-size: 22px;
          font-weight: 700 !important;
        }
      }

      .content {
        display: flex;
        flex-direction: column;
        gap: 16px;

        p {
          margin: 0;
          font-size: 18px;
          letter-spacing: 0;
          line-height: 20px;

          strong {
            font-weight: 600;
          }
        }
          
        .centered {
          text-align: center;
        }
      }

      footer {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
        margin-top: 50px;
        padding: 0;
        min-height: auto;
        gap: 16px;

        .button-container {
          width: 100%;
          display: flex;
          justify-content: center;
        }
      }
    }
  }

  @media screen and (max-width: 768px){
    .frame {
      width: 90%;
      max-height: 72vh;

      footer {
        margin-top: 16px !important;
      }
    }
    
    &.small {
      .frame {
        width: 90% !important;
        padding: 20px !important;
      }
    }
  }
`
